import { useId } from 'react';
import { Icon, Tooltip } from '@nazka/nazka.mapframe.components';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';

import './help-tooltip.styl';

function HelpTooltip({
  helpText,
  size = '16px',
}) {
  const id = useId();

  return (
    <Tooltip
      className="help-tooltip"
      tooltip={helpText}
      id={id}
    >
      <Icon
        className="help-tooltip__icon"
        rootElProps={{ 'data-tooltip-id': id }}
        icon={faQuestionCircle}
        size={size}
      />
    </Tooltip>
  );
}

export default HelpTooltip;